exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.HowItWorks__container__3rSsS h1 {\n  color: #000 !important; }\n\n@media (min-width: 992px) {\n  .HowItWorks__container__3rSsS {\n    width: 100%; } }\n\n@media (min-width: 1200px) {\n  .HowItWorks__container__3rSsS {\n    width: 1250px; } }\n\n.HowItWorks__video-placeholder__3IzI1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: gray;\n  width: \"100%\";\n  height: 400px; }\n", ""]);

// exports
exports.locals = {
	"container": "HowItWorks__container__3rSsS",
	"video-placeholder": "HowItWorks__video-placeholder__3IzI1"
};